var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_vm._v("NPay Test")]),_c('button',{on:{"click":_vm.nPayReg}},[_vm._v("정기결제 등록")]),_c('div',[_vm._v(" "+_vm._s(_vm.msg))])])}
var staticRenderFns = []

export { render, staticRenderFns }